import { Redirect } from "expo-router";
import React from "react";

function DashboardScreen() {
  return <Redirect href="/(app)/home" />;
}

export default DashboardScreen;
